import React from 'react'
import { connect } from 'redaction'

import Section from 'components/cart/Section/Section'
import Product from 'components/cart/Product/Product'

import s from './Products.scss'


const CartProducts = ({ className, cart }) => {
  const { items: { beautyBag: { items: beautyBagItems }, products } } = cart

  return (
    <div className={className}>
      {
        beautyBagItems.map((item, id) => (
          <div key={id} className={s.item}>
            <Product data={item} isCounterVisible={false} isRemoveVisible={false} />
          </div>
        ))
      }
      <Section>
        {
          products.ids.map((id) => (
            <div key={id} className={s.item}>
              <Product data={products.items[id]} />
            </div>
          ))
        }
      </Section>
    </div>
  )
}


export default connect({
  cart: 'models.cart',
})(React.memo(CartProducts))
